import { ReactNode } from 'react';
import type { LoadingSkeletonProps } from '../StyledLoadingSkeleton/index.js';

export interface WrappedLoadingSkeletonProps extends LoadingSkeletonProps {
    children: ReactNode;
    isLoading: boolean;
}

/** See index.d.ts for @finn-no/tjt-common-components for end user documentation.
 */
const WrappedLoadingSkeleton = (props: WrappedLoadingSkeletonProps) => {
    const { isLoading, className, style, children } = props;
    if (isLoading) {
        return (
            <div className={`tjt-skeleton ${className ?? ''}`} style={style}>
                <span className="invisible" style={{ opacity: 0 }}>
                    {children}
                </span>
            </div>
        );
    }
    return <>{children}</>;
};

export default WrappedLoadingSkeleton;
